import Table from './Table';
import THead from './THead';
import TBody from './TBody';
import Tr from './Tr';
import Th from './Th';
import Td from './Td';

export default Table;
export {
  THead,
  TBody,
  Tr,
  Th,
  Td,
};
